import React, { useEffect, useState } from "react";
import "./Terms_condition.css";
import { fetchCmsDataApi } from "../../../../services/faqs";
import { toastMessage } from "../../../../utils/toastMessage";
import useShimmer from "../../../../hooks/useShimmer";
import CmsShimmer from "../../../../shimmer/CMS/CmsShimmer";

const Terms = () => {
  const [termData, setTermData] = useState("");
  const [showShimmer, setShowShimmer] = useShimmer(CmsShimmer);

  const getTermsHandler = async () => {
    try {
      setShowShimmer(true);
      const { data } = await fetchCmsDataApi({ type: "TERMS" });
      const { data: term, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "term");
        setTermData(term);
      } else {
        toastMessage(message, "error", "term");
      }
    } catch (e) {
      console.log("Login:-", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // console.log(termData, "termData");

  useEffect(() => {
    getTermsHandler();
  }, []);
  return (
    <>
      <div className="Privacy_policy">
        <div className="container_privacy_policy">
          <h3 className="profile_title">Terms & Conditions</h3>
          {showShimmer || (
            <p
              dangerouslySetInnerHTML={{
                __html: termData?.description,
              }}
            ></p>
          )}
        </div>
      </div>
    </>
  );
};

export default Terms;
